import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import TtamAge from './age/index.vue';
import TtamAgeTips from '../age/tips/index.vue';
import VueI18n from 'vue-i18n';

const name = 'ttam-age-compose-flex';
export default defineComponent({
  name,
  components: {
    TtamAge,
    TtamAgeTips,
  },
  props: {
    ageOptions: {
      type: Array as PropType<
        {
          key: string;
          label: string;
          id: number;
          value: string;
          text: VueI18n.TranslateResult;
        }[]
      >,
      default: () => [],
    },
    ageState: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    showAgeLegalPrompt: {
      type: Boolean,
    },
    buttonWidth: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const { ageState } = toRefs(props);
    const _age = computed({
      get: () => ageState.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });

    return {
      name,
      _age,
    };
  },
});
